import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URI,
});
// API.defaults.headers.common['X-Client-ID'] = 'client1';
export { API };
